import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants/apiconstants/domainUrl'
import { checkAuthorization } from '../../../helpers'
import { message } from 'antd'

export const getUpdateProfile = createAsyncThunk('getProfile',
    async (_, { dispatch, getState }) => {

        const { userToken }= checkAuthorization()
        dispatch(gettingProfile())
        var myHeaders = new Headers()
        myHeaders.append("Authorization", userToken)
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        fetch(domainUrl + `/getProfile`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(getProfileResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(getProfileResponse())
                message.error(error) 
            })
    }
)

const GetProfileSlice = createSlice({
    name: 'ProfilegetApi',
    initialState: {
        profiledata:null,
        loadingprofile:false,
    },
    reducers: {
        gettingProfile: (state, action) => {
            state.loadingprofile = true
            state.profiledata = null
        },
        getProfileResponse: (state, action) => {
            state.profiledata = action.payload
            state.loadingprofile = false
        }
    },
})

export const { gettingProfile, getProfileResponse } = GetProfileSlice.actions
export default GetProfileSlice.reducer